import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';

@Injectable()
export class JWTTokenService {
  public jwtToken: string;
  public jwtRefreshToken: string;
  decodedToken: { [key: string]: string };
  expiredDate: Date;

  constructor(private cookieService: CookieService) {
    this.jwtToken = this.getJwtCookie(environment.sessionTokenName);
  }

  setToken(token: string): void {
    if (token) {
      this.jwtToken = token;
      this.setJwtCookie(environment.sessionTokenName, token);
    }
  }

  setJwtCookie(cookieName, token): void {
    this.cookieService.set(cookieName, token, 30, '/', 'scm3d.com', true, 'Strict');
  }

  removeToken(): void {
    this.cookieService.deleteAll('/', 'scm3d.com');
  }

  getJwtCookie(cookieName: string): string {
    return this.cookieService.get(cookieName);
  }

  decodeToken() {
    if (this.jwtToken) {
      this.decodedToken = jwt_decode(this.jwtToken);
    }
  }

  getDecodeToken() {
    return jwt_decode(this.jwtToken);
  }

  getUser() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken.fullname : null;
  }

  getEmailId() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken.email : null;
  }

  getExpiryTime() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken.exp : null;
  }

  isTokenExpired(): boolean {
    const expiryTime: any = this.getExpiryTime();
    if (expiryTime) {
      return 1000 * expiryTime - new Date().getTime() < 5000;
    } else {
      return false;
    }
  }
}
